import React, { useState } from 'react';
import './Modal.css';

export const Modal = ({ isOpen, onClose, onSelect, customers }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!isOpen) return null;

  const filteredCustomers = customers.filter(customer =>
    customer.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Select a Customer</h2>
        <input
          type="text"
          placeholder="Search customers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <ul>
          {filteredCustomers.map((customer) => (
            <li key={customer.id} onClick={() => onSelect(customer.id, customer.name)}>
              {customer.name}
            </li>
          ))}
          {filteredCustomers.length === 0 && (
            <li className="no-results">No customers found</li>
          )}
        </ul>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default Modal;